import { render, staticRenderFns } from "./abnormal-order.vue?vue&type=template&id=11c855c3&scoped=true&"
import script from "./abnormal-order.vue?vue&type=script&lang=js&"
export * from "./abnormal-order.vue?vue&type=script&lang=js&"
import style0 from "./abnormal-order.vue?vue&type=style&index=0&id=11c855c3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11c855c3",
  null
  
)

export default component.exports